import { useQuery } from "@tanstack/react-query"
import { getSummary } from "src/redux/api/_hr.api"

export const useSummary = () => {
  return useQuery({
    queryKey: ["hr-attendance-summary"] as const,
    queryFn: () => getSummary(),
    staleTime: 60 * 60 * 1000 * 3,
    gcTime: 60 * 60 * 1000 * 3,
  })
}